'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
Entry.BlockModel = /*#__PURE__*/(0, _createClass2["default"])(function BlockModel(context) {
  (0, _classCallCheck2["default"])(this, BlockModel);
  Entry.Model(this);
  this.schema = {
    id: null,
    x: 0,
    y: 0,
    type: null,
    params: {},
    statements: {},
    prev: null,
    next: null,
    view: null
  };
});